import { v4 as uuid } from 'uuid';

const URL_REF_RE = /url\(#([^)]+)\)/g;

export function fillUniqueUrls(svgHtml: string) {
    const idMatchingMap: Record<string, string> = {};
    let updatedSvgHtml = svgHtml.replace(URL_REF_RE, (_match, oldId) => {
        // TODO: добавить хэширование на основе содержимого, чтобы генерация с BFF совпадала с клиентской генерацией
        const newId = uuid();
        idMatchingMap[oldId] = newId;
        return `url(#${newId})`;
    });

    Object.entries(idMatchingMap).forEach(([oldId, newId]) => {
        // Ищем атрибут id с двойными кавычками и заменяем только непосредственно идентификатор
        updatedSvgHtml = updatedSvgHtml.replace(new RegExp(`(id=")${oldId}(")`, 'g'), `$1${newId}$2`);
    });

    return updatedSvgHtml;
}
